import { debug } from 'app/infrastructure/log';
import { AppSetting } from 'dependencies/appsettings';
import { concatUrl } from 'app/infrastructure/universal/url';
import { globalVar } from 'app/infrastructure/universal';

/**
 * Adds the hosting path in front of the provided URL.
 * Use only with trusted URLs since it will not handle escaping and encoding.
 */
export const toAbsoluteUrl = (url: string, includeHostName: boolean = false) => {
  if (!url) {
    return url;
  }
  const separator = url.startsWith('/') ? '' : '/';
  const prefix = includeHostName ? getApplicationUrl() : getHostingPath();
  const prefixWithoutTrailingSlash = includeHostName ? prefix?.replace(/\/$/, '') : prefix;
  return `${prefixWithoutTrailingSlash}${separator}${url}`;
};

/**
 * Removes the hosting base path (if present) from the provided pathname.
 * Ensures the returned path always starts with a slash.
 */
export const removeHostingPath = (pathName: string): string => {
  if (!pathName) { return pathName }

  const baseUrl = getHostingPath(); 
  let trimmedPath = pathName;
  if (
    baseUrl &&
    baseUrl !== '/' &&
    pathName.startsWith(baseUrl)
  ) {
    trimmedPath = pathName.slice(baseUrl.length);
  }
  return trimmedPath.startsWith('/') ? trimmedPath : `/${trimmedPath}`;
};

/**
 *  Returns the application base path setting from app.config
 */
export function getHostingPath() {
  return globalVar('baseUrl') || AppSetting.HostingPath;
}

/**
 * Returns the full application url including hosting path
 */
export function getApplicationUrl() {
  return AppSetting.ApplicationUrl;
}

export function getAdminApiUrl() {

  return AppSetting.AdminApiBaseUrl;

}

export function getNotificationsApiUrl() {

  return AppSetting.NotificationsApiBaseUrl;

}

export function isCaseViewModalEnabled() {
  return !!(AppSetting.FeatureToggle || {} as any).caseViewModalEnabled;
}

export function isExternalUserHandlingEnabled() {
  return AppSetting.ExternalUserHandlingEnabled;
}

export function getCreateUserLink() {
  return AppSetting.CreateUserLink;
}

export function getDeleteUserLink() {
  return AppSetting.DeleteUserLink;
}

export function isLocalLogin(oidcServiceUrl: string, oidcClientId: string) {
  const storageUser = window.sessionStorage.getItem(`oidc.user:${oidcServiceUrl}:${oidcClientId}`);
  return JSON.parse(storageUser)?.profile?.idp === 'local';
}

export function getAiChatBaseUrl() {
  return AppSetting.AiChat?.baseUrl;
}

export function isSaveAsDraftEnabled() {
  return !!AppSetting.FeatureToggle?.saveAsDraftEnabled;
}

export function getSctwLink() {
  return AppSetting?.SCTWLink;
}

/**
 * Webpack workaround to support hosting in a virtual dir
 * Sets the webpack require base path.
 * Used when lazy loading files after app start.
 * 
 * It fixes the issue with relative hosting path by stripping the first dot
 */
// eslint-disable-next-line no-underscore-dangle
declare let __webpack_public_path__: string;
export function configureSystemImport() {

  __webpack_public_path__ = __webpack_public_path__.replace(/(^.\/)/g, '/');

  const hostingPath = AppSetting.HostingPath;

  if (!hostingPath) {
    return;
  }

  __webpack_public_path__ = `${concatUrl(hostingPath, __webpack_public_path__)}/`;
  debug('System import base is', __webpack_public_path__);

}
